import { FC } from "react";
import Container from "react-bootstrap/Container";
import { ReportVersionTestTypePrerequisites } from "../report-test-type-prerequisite/ReportVersionTestTypePrerequisites";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useRouteParams } from "app/route/route";
import { reportVersionTestTypePrerequisitesRoute } from "app/route/Routes";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";

export const ReportVersionTestTypePrerequisitesScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionTestTypePrerequisitesRoute);

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionTestTypePrerequisitesRoute} className="d-print-none" />
                <ReportVersionTestTypePrerequisites reportId={reportId} versionId={versionId} />
            </Container>
        </NavigationScreen>
    );
};
